module.exports = __webpack_public_path__ + "static/media/zoomy1_preview.12bd5943.jpg";